/**
 * FP&A: vínculo gerencial de cada parcela do rateio da compra (item × centro de custo) com o
 * lançamento do Budget (migração 0279). Só rastreia a origem: não reserva nem consome orçamento,
 * não bloqueia a compra e não muda valores.
 */
import { z } from 'zod';

const uuid = z.uuid();
const reason = z.string().trim().min(3, 'Informe o motivo').max(1000);

/**
 * Situação da parcela: ligada (escolhida no FP&A), pela referência do item (só a área pagadora,
 * quando é compatível), sugerida (um lançamento compatível), ambígua (mais de um: a pessoa
 * escolhe) ou sem linha no orçamento.
 */
export const FPA_PURCHASE_LINK_STATES = [
  'linked',
  'item',
  'suggested',
  'ambiguous',
  'none',
] as const;
export type FpaPurchaseLinkState = (typeof FPA_PURCHASE_LINK_STATES)[number];

/** Ligar a parcela a um lançamento (ou corrigir: o anterior fica no histórico, com o motivo). */
export const fpaPurchaseLinkInput = z.object({
  requestItemId: uuid,
  costCenterId: uuid,
  expenseId: uuid,
  reason: reason.optional(),
});
export type FpaPurchaseLinkInput = z.infer<typeof fpaPurchaseLinkInput>;

/** Desfazer o vínculo: a parcela volta a "Sem vínculo" (ou à sugestão), com o motivo. */
export const fpaPurchaseLinkUndoInput = z.object({
  requestItemId: uuid,
  costCenterId: uuid,
  reason,
});
